export const HERO_SLIDES = [
  {
    id: 1,
    src: "https://solsticeprod.s3.ap-south-1.amazonaws.com/website-content/lead-gen/design-ideas/Kitchen%20Updated.png",
    alt: "Home interior project photographed on-site",
  },
  {
    id: 2,
    src: "https://solsticeprod.s3.ap-south-1.amazonaws.com/website-content/lead-gen/design-ideas/Living%20Updated.png",
    alt: "Home interior project photographed on-site",
  },
  {
    id: 3,
    src: "https://solsticeprod.s3.ap-south-1.amazonaws.com/website-content/lead-gen/design-ideas/Study%20updated.png",
    alt: "Home interior project photographed on-site",
  },
  {
    id: 4,
    src: "https://solsticeprod.s3.ap-south-1.amazonaws.com/website-content/lead-gen/design-ideas/Gemini_Generated_Image_5hnq3m5hnq3m5hnq.png",
    alt: "Home interior project photographed on-site",
  },
];
